// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vuex from 'vuex'
import App from './App'
import router from './router'
import axios from 'axios';
// import BaiduMap from 'vue-baidu-map'
import qs from 'qs'
import  VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'; // 注意路径是 swiper/css/swiper.min.css // 引入 Swiper 的样式文件 // 引入 Swiper 的样式文件
import VueWechatTitle from 'vue-wechat-title'
import Vant from 'vant';
import 'vant/lib/index.css'; // 引入 Vant 的样式文件
Vue.use(Vant); // 全局注册 Vant 组件
window.appScanCodeResult = function(val) {
	window.appScanCodeResultString = val
	window.dispatchEvent(new CustomEvent("scanCodeResult"))

}
window.downloadcomplete = function(val) {
	window.downloadFileIndex = val
	window.dispatchEvent(new CustomEvent("handleComplete"))

}
// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: 'YOUR_APP_KEY'
// })

axios.defaults.timeout = 10000; //请求超时
axios.defaults.baseURL = 'https://www.tmm6.cn/travelwalkman/guideScenics';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.use(VueAwesomeSwiper)
Vue.use(vuex)
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.prototype.$http = axios;

var store = new vuex.Store({
  state: {
    isLoading:false
  }
})

axios.interceptors.request.use(
  config => {
  // console.log(JSON.stringify(config))
   return config;
  },
  error => {
   return Promise.reject(err);
  }
 );

 //http response 拦截器
 axios.interceptors.response.use(
  response => {
   //console.log(response)
   var res = response.data
   if(response.data.state == 200) {
 
   }
   return res;
  },
  error => {
   return Promise.reject(error)
  }
 )
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js